import baseContext from '../core/Context';

var _baseContext = baseContext(undefined),
    connect = _baseContext.connect,
    Provider = _baseContext.Provider;

export { connect, Provider };